import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/cedar-park")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Cedar Park, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Cedar Park & Williamson County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Cedar Park, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Cedar Park and Williamson County.",
      keywords: "awnings Cedar Park, awning company Cedar Park, custom awnings Cedar Park, sail shades Cedar Park, patio covers Cedar Park, pergola covers Cedar Park, metal awnings Cedar Park, canvas awnings Cedar Park, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Cedar Park", "Williamson County"),
  }),
  component: () => <CityHomePage city="Cedar Park" region="Williamson County" />,
});
